export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8991.135f5393.jpg";